import { Observer } from 'mobx-react-lite';
import type { JSX } from 'react';
import React from 'react';

import type { BaseCampaign } from '@feathr/blackbox';
import type { IColumn } from '@feathr/components';
import { TableColumnHeader } from '@feathr/components';

import * as tableStyles from '@feathr/components/dist/Table/Table.css';

const EmailUnsubscribesColumn: IColumn<BaseCampaign> = {
  id: 'stats_cache__num_persons_unsubscribed',
  checkboxLabel: 'Unsubscribes',
  Header: TableColumnHeader({
    title: 'Unsubscribes',
  }),
  width: 110,
  sortable: false,
  className: tableStyles.cellRight,
  Cell({ original }): JSX.Element {
    return (
      <Observer>
        {(): JSX.Element => {
          const stats = original.get('stats_cache');
          const unsubscribes = stats?.num_persons_unsubscribed || 0;
          return <>{unsubscribes.toLocaleString()}</>;
        }}
      </Observer>
    );
  },
  Footer({ data }): JSX.Element {
    return (
      <Observer>
        {(): JSX.Element => {
          const total = data.reduce((subtotal, currentValue) => {
            const stats = currentValue._original.get('stats_cache');
            const unsubscribes = stats?.num_persons_unsubscribed || 0;
            return subtotal + unsubscribes;
          }, 0);
          return <>{total.toLocaleString()}</>;
        }}
      </Observer>
    );
  },
};

export default EmailUnsubscribesColumn;
